<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    <div class="header-image-gradient" style="background-image: url(static/images/img6.jpg); background-position: 0 6%;">
                        <div class="layer-gradient"></div>
                    </div>                     

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        
                        <div class="col-lg-12 col-xs-12 col-xl-12" v-if="$root.user.tipo == 'contratante' || $root.user.tipo == 'profissional'">
                            <p class="page-text margin-bottom-15">
                                Confira abaixo todos os seus agendamentos próximos.
                            </p>
                            <div class="submit-field" v-if="$root.user.tipo == 'profissional' || $root.user.tipo == 'admin'">
                                <div class="checkbox margin-bottom-0">
                                    <input type="checkbox" class=""  id="filtro-hoje" v-model="form.filtro" true-value="hoje" false-value="" @change="get(true)">
                                    <label for="filtro-hoje"><span class="checkbox-icon"></span> Agendamentos para  <b>hoje</b></label>
                                </div>
                            </div>                                
                            <div class="submit-field" v-if="$root.user.tipo == 'profissional' || $root.user.tipo == 'admin'">
                                <div class="checkbox margin-bottom-0">
                                    <input type="checkbox" class=""  id="filtro-teleconsulta" v-model="form.filtro" true-value="teleconsultas" false-value="" @change="get(true)">
                                    <label for="filtro-teleconsulta"><span class="checkbox-icon"></span> Filtrar por <b>teleconsultas</b></label>
                                </div>
                            </div>    
                            <div class="submit-field" v-if="$root.user.tipo == 'profissional' || $root.user.tipo == 'admin'">
                                <div class="checkbox margin-bottom-0">
                                    <input type="checkbox" class=""  id="filtro-proximos" v-model="form.filtro" true-value="proximos" false-value="" @change="get(true)">
                                    <label for="filtro-proximos"><span class="checkbox-icon"></span> Filtrar por <b>próximos</b></label>
                                </div>
                            </div>
                            <div class="submit-field" v-if="$root.user.tipo == 'profissional' || $root.user.tipo == 'admin'">
                                <div class="checkbox margin-bottom-5">
                                    <input type="checkbox" class=""  id="filtro-data" v-model="form.filtroData" true-value="1" false-value="0" @change="get(true)">
                                    <label for="filtro-data"><span class="checkbox-icon"></span> Filtrar por <b>data</b></label>
                                </div>
                                <div class="row" v-if="form.filtroData == 1">
                                    <div class="col-xs-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-30">
                                            <h5>Data da agenda</h5>
                                            <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.data" required="">
                                        </div>                                        
                                    </div>
                                    <div class="col-xs-3 col-xl-1 col-lg-1">
                                        <button type="button" class="button gray small" v-on:click="get(true)" style="margin-top: 20px; width: 100%; height: 40px;">
                                            <i class="las la-search" style="font-size: 18px;"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>                            
                        </div>
<!--                         <div class="col-lg-12 margin-bottom-15 hidden-xl" v-if="$root.user.tipo == 'contratante'">
                            <router-link :to="{'name': 'Profissionais'}" class="button block-mobile " style="box-shadow: none;">
                                <i class="material-icons">add</i>
                                Quero fazer um agendamento
                            </router-link>
                        </div>
 -->
                        <div class="col-lg-12 col-xs-12 col-xl-12" v-if="$root.user.tipo == 'admin'">
                            <p class="page-text margin-bottom-15">
                                Confira abaixo todos os agendamentos próximos.
                            </p>
                        </div>                        

                        <div class="col-xl-12 col-xs-12">
                            <div class="dashboard-box margin-top-15 cards agendamentos">
                                <div class="content">
                                    <h5 class="block-title">
                                        <i class="las la-list"></i>
                                        Lista de agendamentos
                                    </h5>
                                    <h5 v-if="data.itens.length == 0 && data.loaded" class="empty">
                                        <i class="las la-times"></i>                                           
                                        Nenhum resultado encontrado.
                                    </h5>                                    
                                    <ul class="dashboard-box-list">
                                        <li v-for="(item, index) in data.itens">
                                            <router-link :to="{'name': (item.DS_CLASSIF_AGENDA == 'Teleconsulta' ? 'Teleconsulta' : 'Agendamentos'), 'query': (item.DS_CLASSIF_AGENDA == 'Teleconsulta' ? {'NR_SEQUENCIA': item.NR_SEQUENCIA} : {})}" class="job-listing card2">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <h3 class="job-listing-title">
                                                                    <i class="las la-clock"></i>
                                                                    <b>
                                                                        {{item.HR_INICIO | formatDate}}h
                                                                    </b>
                                                                </h3>
                                                                <span class="dashboard-status-button" :class="{'green': item.DS_STATUS_AGENDA.trim() == 'Executada' || item.DS_STATUS_AGENDA.trim() == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA.trim() == 'Aguardando' || item.DS_STATUS_AGENDA.trim() == 'Aguardando consulta' || item.DS_STATUS_AGENDA.trim() == 'Pré-agenda', 'color-red': item.DS_STATUS_AGENDA.trim() == 'Cancelada' || item.DS_STATUS_AGENDA.trim() == 'Falta não justificada' || item.DS_STATUS_AGENDA.trim() == 'Inativo' || item.DS_STATUS_AGENDA.trim() == 'Falta não justificada' || item.DS_STATUS_AGENDA.trim() == 'Bloqueada' || item.DS_STATUS_AGENDA.trim() == 'Falta não Justificada', 'color-blue': item.DS_STATUS_AGENDA.trim() == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA.trim() == 'Normal'}">
                                                                    {{item.DS_STATUS_AGENDA}}
                                                                </span>
                                                                <small>
                                                                    <!-- <i class="material-icons">smartphone</i> -->
                                                                    {{item.DS_COMPLEMENTO}}
                                                                    <!-- Teleconsulta -->
                                                                </small>                                                                
                                                            </div>


                                                            <div class="col-lg-12">
                                                                <small style="font-size: 12px;">Informações:</small>
                                                                <div class="job-listing-footer">

                                                                    <ul class="margin-top-0">
                                                                        <li v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'profissional'" v-on:click.stop.prevent="$root.go('Paciente', JSON.stringify({'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}))">
                                                                            <i class="las la-user"></i>
                                                                            Paciente: <b><u>{{item.NM_PACIENTE}}</u></b>
                                                                        </li>
                                                                        <li v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'contratante' || $root.user.tipo == 'gerente' || $root.user.tipo == 'controladoria' || $root.user.tipo == 'coordenador'">
                                                                            <i class="las la-first-aid"></i>
                                                                            Profissional: <b>{{item.NM_MEDICO_AGENDA}}</b>
                                                                        </li>
                                                                        <br>
                                                                        <li>
                                                                            <i class="las la-chevron-circle-right"></i> 
                                                                            Tipo: <b>{{item.DS_TIPO_AGENDA}} {{item.DS_CLASSIF_AGENDA != 'Consulta' ? "/ " + item.DS_CLASSIF_AGENDA + "" : ''}}</b>
                                                                        </li>                                                                                                                                
                                                                        <!-- <br> -->
                                                                        <!-- <li>
                                                                            <i class="las la-clock"></i> 
                                                                            Agendada em: <b>{{item.DT_CONFIRMACAO | }}</b>
                                                                        </li>       -->                                                                
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-12 margin-top-10" v-if="($root.user.tipo == 'contratante' || $root.user.tipo == 'profissional') && item.DS_CLASSIF_AGENDA == 'Teleconsulta' && item.IE_STATUS_AGENDA != 'C' && item.IE_STATUS_AGENDA != 'AD' && item.IE_STATUS_AGENDA != 'E'">
                                                                <a class="button green block-mobile">
                                                                    <i class="las la-video"></i>
                                                                    Acessar teleconsulta
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li>
                

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Agendamentos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "filtroData":       false,
                "data":             null
            },
        }
    },
    watch: {
                  
    },
    methods: {             
        get: function(force) {
            var self        = this;
            console.log("get()");
            loading.show();
            return new Promise(function(resolve, reject) {

                if (!force) {
                    if (self.$root.tmp.agendamentos.itens.length > 0) {
                        self.data  = JSON.parse(JSON.stringify(self.$root.tmp.agendamentos));
                        loading.hide();
                        resolve(true);
                    }
                }


                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "filtro":       self.form.filtro,
                        "filtroData":   self.form.filtroData,
                        "data":         self.form.data
                    }
                };

                axios.get("api/agendamento.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    self.$root.tmp.agendamentos = JSON.parse(JSON.stringify(response.data.result));
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        loading.show();

        self.$root.addLog({"acao": "VISUALIZAR_AGENDAMENTOS"});

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            setTimeout(function() {
                loading.hide();
            }, 1000);
            
        }).catch(function(error) {
            loading.hide();
        });      
        self.loading = window.loading;   

    },
    mounted: function() {
        
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
    }
    .dashboard-status-button i {
        color: #fff;
        top: -3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Agendamentos.vue